import { useMe } from '@/auth/useMe';

/**
 * בדיקת הרשאה לפי מפתח, אף פעם לא לפי שם תפקיד (PRD 2.5).
 * הבדיקה בממשק היא נוחות בלבד. ההגנה האמיתית היא RLS.
 */
export function usePerm(key: string): boolean {
  const { me } = useMe();
  return me?.permissions.includes(key) ?? false;
}

/** האם יש לעובד לפחות אחד מהמפתחות. */
export function useAnyPerm(keys: string[]): boolean {
  const { me } = useMe();
  if (!me) return false;
  return keys.some((key) => me.permissions.includes(key));
}

/** האם יש לעובד מפתח ניהול כלשהו (לכניסה לאזור הניהול). */
export function useIsManager(): boolean {
  const { me } = useMe();
  if (!me) return false;
  return me.permissions.some((key) => key.endsWith('.manage') || key.startsWith('admin.'));
}
